import React, { useState } from 'react';
import CupCheck from '../components/CupCheck';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '../components/ui/collapsible';

export const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="home">
      <section className="cup-check-trigger-section">
        <div className="container">
          <Collapsible open={isOpen} onOpenChange={setIsOpen}>
            <div className="cup-trigger-container">
              <CollapsibleTrigger asChild>
                <div className="cup-trigger-content">
                  <h2 className="cup-trigger-title">
                    Are you pouring from an <span className="highlight">empty cup?</span>
                  </h2>
                  <p className="cup-trigger-subtitle">
                    A quick FREE check-in to discover work-life balance and steps to refill your energy!
                  </p>
                  <button className="btn-primary cup-trigger-btn">
                    {isOpen ? 'Hide Assessment' : 'Take Your FREE SIP Assessment'}
                  </button>
                </div>
              </CollapsibleTrigger>
            </div>
            
            <CollapsibleContent>
              <CupCheck />
            </CollapsibleContent>
          </Collapsible>
        </div>
      </section>
      
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
